module.exports = __webpack_public_path__ + "img/header-phone-2.80709c5b.png";